import { GitHub, Instagram, LinkedIn } from "@mui/icons-material";
import Icon from '@mdi/react';
import { mdiSteam } from '@mdi/js';
import "../styles/Footer.css"
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";
import { useCookieModal } from "../helpers/CookieContext";

function Footer() {
    const { language } = useLanguage();
    const t = translations[language].footer;
    const { openCookieModal } = useCookieModal();

    return (
        <div className="footer">
            <div className="social-media">
                <Instagram className="icons" onClick={() => {
                    window.open("https://www.instagram.com/therealfiiocco/", "_blank");
                }} />
                <LinkedIn className="icons" onClick={() => {
                    window.open("https://www.linkedin.com/in/fiocco-antonio", "_blank");
                }} />
                <GitHub className="icons" onClick={() => {
                    window.open("https://github.com/therealfiiocco?tab=repositories", "_blank");
                }} />
                <Icon path={mdiSteam} className="icons steam" onClick={() => {
                    window.open("https://steamcommunity.com/id/therealfiiocco/", "_blank");
                }} />
            </div>
            <p>
                {t.rights} | <span className="cookie-link" onClick={openCookieModal}>{t.cookiePreferences}</span>
            </p>
        </div>
    )
}

export default Footer